import React from 'react';
import {Text, useDevice} from '../../Atoms';
import {Stack} from '../../Layout';
import styles from './ReferralBanner.module.css';
import backgroundImageDesktop from './assets/banner-desktop.webp';
import backgroundImage from './assets/banner.webp';

export type ReferralBannerProps = {
  title: string;
  renderActions: () => React.ReactNode;
};

export const ReferralBanner = ({title, renderActions}: ReferralBannerProps) => {
  const {isMobile} = useDevice();

  return (
    <div className={styles.root}>
      <div className={styles.imageContainer}>
        <img
          src={isMobile ? backgroundImage : backgroundImageDesktop}
          alt=""
          className={styles.image}
        />
      </div>
      <Stack space="xl" className={styles.content}>
        <Text
          as="h2"
          type={isMobile ? 'mdHero' : 'hugeHero'}
          className={styles.text}
        >
          {title}
        </Text>
        <div className={styles.actions}>{renderActions()}</div>
      </Stack>
    </div>
  );
};
